module.exports = __webpack_public_path__ + "static/media/Mosprom_GDPR_PP_ru_152.84edeaee.docx";